import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { getTranslation } from '../data/translations';
import { whatsappConfig } from '../data/mockData';
import { MessageCircle } from 'lucide-react';

const WhatsAppFloat = () => {
  const { language } = useLanguage();
  const t = (key) => getTranslation(language, key);

  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(whatsappConfig.defaultMessage[language]);
    const whatsappUrl = `https://wa.me/${whatsappConfig.number}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <button
      onClick={handleWhatsAppClick}
      className="fixed bottom-6 right-6 z-50 bg-[#25D366] hover:bg-[#20BA5A] text-white rounded-full p-4 shadow-2xl transition-all duration-300 hover:scale-110 group"
      aria-label={t('footer.whatsappFloat')}
    >
      <MessageCircle className="h-7 w-7" />
      <span className="absolute bottom-full right-0 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
        {whatsappConfig.businessName}
      </span>
    </button>
  );
};

export default WhatsAppFloat;
